<template>
    <section>
        <form @submit.prevent="next()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1549')}}
            <!-- 코드 인증 -->
        </div>
        <div class="t-body3 mt6 t-color-bodyGrayA">
            {{$t('1550')}}
            <!-- 인증코드를 입력하세요. -->
        </div>
        <div class="mt38">
            
            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                :class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
                id="codeEl"
            >
                <i class="material-icons mdc-text-field__icon">
                    {{validIcon}}
                </i>
                <input type="text" class="mdc-text-field__input"
                    v-model="code"
                    v-validate="'required|alpha_num'"
                    ref="code"
                    id="code"
                    name="code"
                    maxlength="50"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1551')}}
                        <!-- 코드입력 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            <div class="t-helper text-helper " :class="submitState && codeInvalidCheck ? 'warning' : ''">
                <span v-if="submitState && codeInvalidCheck">
                    {{$t('1560')}}
                    <!-- * 공백이 없는 인증코드를 입력하세요. -->
                </span>
                <span v-else>
                    {{$t('1552')}}
                    <!-- * 본인 및 소속을 확인하기 위한 코드 인증입니다. -->
                </span>
            </div>
        </div>
        <div class="mt26 mb19">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1553')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="cancelJoin()" type="button" tabindex="0">
                {{$t('1554')}}
                <!-- 취소 -->
            </button>
        </div>

        <div class="t-body4 t-color-bodyGrayA mt30">
            <a class="text-blue" @click="showMessage(1)" tabindex="0">
                {{$t('1555')}}
                <!-- 인증코드를 잊으셨나요? -->
            </a>
                {{$t('1556')}}
                <!-- 혹은 -->
            <a class="text-blue" @click="showMessage(2)" tabindex="0">
                {{$t('1557')}}
                <!-- 인증코드가 없으신가요? -->
            </a>
        </div>

        <!-- <div><br><br><br>
            인증코드 참고<br>
            Elementary01<br>
            Elementary02<br>
            Elementary03<br>
            Elementary04<br>
            Elementary05<br>
            Elementary06<br>
        </div> -->
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            code: '',
            codeTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [joinMixin],
    
    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // code 유효성 Check 및 아이콘
        codeInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('code')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = ''
                }
            }
            this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
            return returnValue
        },

    },
    created() {
        if (!this.join.role) {
            // this.$router.go(-1)
        }
    },
    mounted() {
        this.setMaterialUi()
        this.$refs.code.focus()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_STORE']),

        setMaterialUi() {
            this.codeTextField = new MDCTextField(document.querySelector('#codeEl'))
            this.codeTextField.useNativeValidation = false
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let params = { code: this.code }
                    let reponseData = null
                    joinApi.auth(params).then((response) => {
                        reponseData = response.data.data
                        
                        if (reponseData.responsibility) {
                            this.SET_RESPONSIBILITY(reponseData.responsibility.id)
                        }

                        if (reponseData.store) {
                            this.SET_STORE(reponseData.store.id)
                        }

                        this.$router.push({name: 'JoinPolicy', query: this.$route.query})

                    }).catch((err) => {
                        // this.$snackOpen({contents:'인증에 실패했습니다. 코드를 확인해주세요.', btnDisplayYN: false}).then(() => {})
                        this.$snackOpen({contents: this.$t('1558') + ' ' + this.$t('1559'), btnDisplay:''}).then(() => {})
                    })
                    
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        },

    },

    

}
</script>

<style scoped>

</style>
